import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import {
  setInvitationDetails,
  setInvitationLoading,
  setInvitationOpen,
  setInvitationPreview,
  setInvitationTheme,
  setIsFromPortfolio,
} from "../../store/actions/action";
import { connect } from "react-redux";
import { callInvitationAPI } from "../../utils/api";
import MarketingBanner from "./Modal";
import { getQueryParamFromUrl, isPreviewTemplateWithPath } from "../../utils";
import AmantrikaHome from "../../components/AmantrikaHome/AmantrikaHome";
// Each theme's page, preview data, music, loader, opening and heart bubbles
import { getThemeConfig } from "../../themes/registry";
import { isSouthIndianInvite } from "../../components/Utsav/helpers";

import BirthdayHome from "../BirthdayHome/BirthdayHome";
// import BannerBirthday from "../BirthdayHome/BannerBirthday";
import Envelop, { RevealFlash } from "../../components/Envelop/Envelop";
import HeartBubbles from "../../components/HeartBubbles/HeartBubbles";

// Keyed by the song, so a different song loads a fresh <audio> (changing <source> alone
// doesn't reload it).
const Music = ({ song }) => (
  <audio id="backgroundMusic" loop key={song}>
    <source src={song} type="audio/mpeg" />
  </audio>
);

// Each invite link's theme is remembered once it has loaded, so the next visit can
// show that theme's own loader before the invite comes back.
const themeKey = (pathname) => `amantrika-theme:${pathname}`;
const readKnownTheme = (pathname) => {
  try {
    return pathname ? localStorage.getItem(themeKey(pathname)) : null;
  } catch (error) {
    return null;
  }
};

const InvitationWrapper = (props) => {
  const { isInviteOpen, theme, loading, isSouthIndian } = props;

  const location = useLocation();
  const navigate = useNavigate();

  const themeName = getQueryParamFromUrl(location?.search, "theme");
  const refParam = getQueryParamFromUrl(location?.search, "ref");
  const isFromPortfolio = refParam === "portfolio"


  let { pathname } = useParams();
  const [noInvite, setNoInvite] = useState(false);
  const [showMarketingBanner, setShowMarketingBanner] = useState(false);
  const [isBirthday, setIsBirthday] = useState(false);
  const [petals, showPetals] = useState(false);

  const isPreviewWithPath = isPreviewTemplateWithPath(
    pathname,
    location?.pathname,
  );
  const isPreview = location?.pathname?.includes("/preview");
  const [knownTheme] = useState(() => themeName || readKnownTheme(pathname));
  const themeConfig = getThemeConfig(theme);
  // A South Indian wedding gets the theme's South Indian song, when the theme has one
  const song = (isSouthIndian && themeConfig.southIndianMusic) || themeConfig.music;

  useEffect(() => {
    if (loading || !pathname || !theme) return;
    try {
      localStorage.setItem(themeKey(pathname), theme);
    } catch (error) {
      // storage unavailable (private mode); the shared loader is used next time
    }
  }, [loading, pathname, theme]);

  useEffect(() => {
    if (isPreviewWithPath) {
      sessionStorage.setItem("isPreviewWithPath", true);
      handlePreviewWithPath();
    } else if (!isPreview && pathname) {
      sessionStorage.setItem("isPreviewWithPath", false);
      getInvitationData();
    } else if (isPreview && !pathname) {
      sessionStorage.setItem("isPreviewWithPath", false);
      handlePreview();
      props.setInvitationLoading(false);
    } else {
      sessionStorage.setItem("isPreviewWithPath", false);
      props.setInvitationLoading(false);
      handleNoInvite();
    }
  }, []);

  useEffect(() => {
    if (isInviteOpen && pathname) {
      setTimeout(() => {
        // setShowMarketingBanner(true);
      }, 30000);
    }
  }, [isInviteOpen]);

  const handlePreview = () => {
    props.setInvitationPreview(true);
    props.setInvitationTheme(themeName);
    props.setInvitationDetails(getThemeConfig(themeName).previewData);
  };

  const handlePreviewWithPath = () => {
    getInvitationData();
  };

  const getInvitationData = async () => {
    let { invite, status } = await callInvitationAPI(
      pathname,
      isPreviewWithPath,
    );
    if (status === 200) {
      props.setInvitationDetails(invite);
      props.setInvitationLoading(false);
      props.setIsFromPortfolio(isFromPortfolio)
      // autoOpenInvite();
    } else {
      handleNoInvite();
      props.setInvitationLoading(false);
    }
  };

  const handleNoInvite = () => {
    props.setInvitationLoading(false);
    navigate("/");
    setNoInvite(true);
  };

  const playMusicOnOpen = () => {
    const audio = document.getElementById("backgroundMusic");
    audio.play();
  };

  const handleOpenInvite = () => {
    playMusicOnOpen();
    showPetals(true);
    props.setInvitationOpen(true);
  };

  const renderThemeBasedPage = () => {
    if (loading) {
      // The theme isn't known until the invite loads; use the one remembered for this link
      const { Loader } = getThemeConfig(knownTheme);
      return <Loader />;
    }
    const { Page } = themeConfig;
    return <Page onOpenInvite={handleOpenInvite} />;
  };

  // The shared envelope opens the invite, unless the theme draws its own opening
  const showEnvelope = !isInviteOpen && !loading && !themeConfig.opensItself;

  const renderInvite = () => {
    return (
      <>
        {/* <div style={{ display: isInviteOpen ? "none" : "block" }}>
          <div className="inviteBannerWrapper">
            {isBirthday ? (
              <BannerBirthday onOpenInvite={handleOpenInvite} />
            ) : (
              <Banner />
            )}
          </div>
          <Envelop onOpenInvite={handleOpenInvite} loading={loading} />
        </div> */}
        <div>
          <RevealFlash active={isInviteOpen} />
          {/* The theme isn't known until the invite has loaded, so wait (loader) rather than flash the envelope. */}
          {showEnvelope ? (
            <Envelop onOpenInvite={handleOpenInvite} loading={loading} />
          ) : (
            renderThemeBasedPage()
          )}

          {showMarketingBanner && (
            <MarketingBanner onClose={() => setShowMarketingBanner(false)} />
          )}
          {!loading && themeConfig.heartBubbles && <HeartBubbles trigger={petals} duration={5000} />}
          {theme !== "" && <Music song={song} />}
        </div>
      </>
    );
  };

  return noInvite ? <AmantrikaHome /> : renderInvite();
};

const mapStateToProps = (state) => {
  return {
    isInviteOpen: state.inviteDetails?.isOpen || false,
    theme:
      state.inviteDetails?.invite?.themeInfo?.identifier ||
      state.inviteDetails?.theme ||
      "",
    loading: state.inviteDetails?.loading,
    isSouthIndian: isSouthIndianInvite(state.inviteDetails?.invite),
    bannerPhoto: state.inviteDetails.invite?.bannerPhoto,
    brideName: state.inviteDetails.invite?.bride?.name,
    groomName: state.inviteDetails.invite?.groom?.name,
  };
};

export default connect(mapStateToProps, {
  setInvitationDetails,
  setInvitationOpen,
  setInvitationPreview,
  setInvitationTheme,
  setInvitationLoading,
  setIsFromPortfolio,
})(InvitationWrapper);
//
